module.exports = __webpack_public_path__ + "static/media/arrow-top-dark.7bad4342.png";